import * as React from 'react'
import { MdSearch } from 'react-icons/md'
import { components, DropdownIndicatorProps } from 'react-select'
import { SuggestedPlace, GMapsPredictions } from 'types/googleMaps'

export const DropdownIndicator: React.FC<DropdownIndicatorProps<SuggestedPlace | GMapsPredictions>> = (props) =>
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <MdSearch size={20} />
    </components.DropdownIndicator>
  )

export default DropdownIndicator
